import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";
import toast from "react-hot-toast";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";

const AddPostModal = ({ isOpen, onClose, onSubmit, categories = [] }) => {
    const [title, setTitle] = useState("");
    const [category, setCategory] = useState("");
    const [content, setContent] = useState("");
    const [media, setMedia] = useState(null);
    const [error, setError] = useState("");

    const [
        uploadImage,
        {
            data: uploadImageData,
            isLoading: uploadImageIsLoading,
            error: uploadImageError,
        },
    ] = useUploadSingleFileMutation();

    useEffect(() => {
        if (uploadImageData) {
            console.log("success image upload", uploadImageData.body);
            let imageLink = uploadImageData.body.fileLink
            onSubmit({ title, category, content, media: imageLink });
            setTitle("");
            setCategory("");
            setContent("");
            setMedia(null);
            setError("");
        }
        if (uploadImageError) {
            toast.error("Image upload failed");
        }

        if (uploadImageIsLoading) {
            toast.loading("Uploading your image...", { id: "uploadImageLoading" });
        }
    }, [uploadImageData, uploadImageError, uploadImageIsLoading]);

    if (!isOpen) return null;

    const handleSubmit = () => {
        const formData = new FormData();
        formData.append("image", media);
        uploadImage({
            body: formData,
        });
    };

    return (
        <ModalComponent show={isOpen} setShow={onClose} size="3xl" showClose={false}>
            {
                uploadImageIsLoading && <CircleLoaderComponent />
            }
            <div className="rounded-2xl bg-white shadow-2xl flex flex-col overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b">
                    <h2 className="text-lg font-semibold text-gray-900">
                        Add New Post
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
                    >
                        ×
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">

                    {/* Title */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Title <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter post title"
                            className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* Category */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Category <span className="text-red-500">*</span>
                        </label>
                        <select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className="w-full rounded-lg border px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value="">Select category</option>
                            {categories.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                    {cat.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Media Upload */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Media Upload
                        </label>
                        <input
                            type="file"
                            accept="image/*,video/*"
                            onChange={(e) => setMedia(e.target.files[0])}
                            className="block w-full text-sm text-gray-600
                                file:mr-4 file:py-2 file:px-4
                                file:rounded-lg file:border-0
                                file:text-sm file:font-medium
                                file:bg-gray-100 file:text-gray-700
                                hover:file:bg-gray-200"
                        />
                        {media && (
                            <p className="mt-1 text-xs text-gray-500">
                                Selected: {media.name}
                            </p>
                        )}
                    </div>

                    {/* Content */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Content <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            rows={5}
                            placeholder="Write your post content..."
                            className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {error && (
                        <p className="text-sm text-red-600">{error}</p>
                    )}
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 px-6 py-4 border-t bg-white">
                    <button
                        onClick={onClose}
                        className="rounded-lg bg-gray-200 px-5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white hover:bg-blue-700"
                    >
                        Submit
                    </button>
                </div>

            </div>
        </ModalComponent>
    );
};

export default AddPostModal;
